import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import Title from '../shared/Title';
import { pathTo } from '../../App/routes';
import BoxScore from '../shared/Boxscore';
import { ExternalLink } from '../shared/Links';
import { getAccessToken } from '../../lib/crossover';
import { useProfile } from '../shared/hooks';

// https://localhost:8000/api/stats/season/657/team/377/takeaway?league_id=1
const getExportLink = (leagueId, seasonId, team) => {
  const accessToken = getAccessToken();
  return (
    team &&
    `/api/stats/season/${seasonId}/team/${team.id}/takeaway?league_id=${leagueId}&token=${accessToken}`
  );
};

const TeamView = ({ leagueId, seasonId, team, lastGame, overflow }) => {
  const profile = useProfile();
  const isSilver = profile?.tier.startsWith('SILVER');

  return (
    <div className="s-team-view">
      <Title
        team={team}
        linkTo=""
        subtitle={
          lastGame
            ? `Overview // ${lastGame.gameCount} Game${
                lastGame.gameCount > 1 ? 's' : ''
              }`
            : 'Overview'
        }
        overflow={overflow}
      />

      {!isSilver && (
        <ExternalLink
          className="btn-info s-team-view__report"
          href={getExportLink(leagueId, seasonId, team)}
          title="Export Season Report"
        />
      )}

      <div className="s-team-view__actions">
        <div className="s-team-view__box">
          <Link
            to={pathTo('games', leagueId, seasonId, team)}
            className="s-team-view__box-main"
          >
            <span className="icon-games" />
            <p className="s-team-view__box-title">Games</p>
          </Link>
        </div>

        <div className="s-team-view__box">
          <LastGame
            route={pathTo('game-explorer', leagueId, seasonId, team, lastGame)}
            lastGame={lastGame}
          />
        </div>

        <div className="s-team-view__box">
          <Link
            to={pathTo('lineups', leagueId, seasonId, team)}
            className="s-team-view__box-main"
          >
            <span className="icon-lineups" />
            <p className="s-team-view__box-title">Lineups</p>
          </Link>
          <div className="s-team-view__box-nav">
            <Link
              to={pathTo('lineups', leagueId, seasonId, team)}
              className="btn-info"
            >
              Summary
            </Link>
            <Link
              to={pathTo('lineup-explorer', leagueId, seasonId, team)}
              className="btn-info"
            >
              Analysis
            </Link>
          </div>
        </div>

        {!isSilver && (
          <div className="s-team-view__box">
            <Link
              to={pathTo('combinations', leagueId, seasonId, team)}
              className="s-team-view__box-main"
            >
              <span className="icon-player-combinations" />
              <p className="s-team-view__box-title">Player Combinations</p>
            </Link>
            <div className="s-team-view__box-nav">
              <Link
                to={pathTo('combinations', leagueId, seasonId, team)}
                className="btn-info"
              >
                Summary
              </Link>
              <Link
                to={pathTo('combination-explorer', leagueId, seasonId, team)}
                className="btn-info"
              >
                Analysis
              </Link>
            </div>
          </div>
        )}

        <div className="s-team-view__box">
          <Link
            to={pathTo('onoff', leagueId, seasonId, team)}
            className="s-team-view__box-main"
          >
            <span className="icon-onoff-metrics" />
            <p className="s-team-view__box-title">OnOff Metrics</p>
          </Link>
        </div>
        <div className="s-team-view__box">
          <Link
            to={pathTo('stats', leagueId, seasonId, team)}
            className="s-team-view__box-main"
          >
            <span className="icon-stats" />
            <p className="s-team-view__box-title">Advanced Stats</p>
          </Link>
        </div>
      </div>
    </div>
  );
};

TeamView.propTypes = {
  team: PropTypes.object,
};

export default TeamView;

const LastGame = ({ lastGame, route }) => {
  return (
    <Link to={route} className="s-team-view__box-main s-team-view__boxscore">
      <BoxScore game={lastGame} />
      <p className="s-team-view__box-title">Last Game</p>
    </Link>
  );
};
